// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip-wrap {
  position: relative;
  display: inline-block;
}

.tt-host {
  position: relative;
  display: inline-block;
  padding: 6px 12px;
  background: var(--bg-alt);
  border: 1px solid var(--border);
  border-radius: var(--radius-0);
  font-size: var(--fs-meta);
  color: var(--text-secondary);
  cursor: help;
}

.tt-host--dark {
  background: var(--ink-dark-2);
  border-color: var(--ink-rule);
  color: var(--ink-text-2);
}

.tooltip-arrow {
  background: var(--ink-dark);
  color: var(--cream);
  padding: 8px 12px;
  border-radius: var(--radius-0);
  font-size: var(--fs-xs);
  line-height: 1.4;
  max-width: 240px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  z-index: var(--z-dropdown);
  white-space: normal;
  pointer-events: none;
}

.tooltip-arrow--top {
  top: auto;
  bottom: calc(100% + 8px);
}

.tooltip-arrow--right {
  left: auto;
  right: 0;
}

.tooltip-arrow::before {
  content: '';
  position: absolute;
  top: -4px;
  left: 24px;
  width: 8px;
  height: 8px;
  background: var(--ink-dark);
  transform: rotate(45deg);
}

.tooltip-arrow--top::before {
  top: auto;
  bottom: -4px;
}
`, "",{"version":3,"sources":["webpack://./src/ui/Tooltip/Tooltip.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,+BAA+B;EAC/B,8BAA8B;EAC9B,yBAAyB;EACzB,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,0BAA0B;EAC1B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,WAAW;EACX,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,YAAY;AACd","sourcesContent":[".tooltip-wrap {\n  position: relative;\n  display: inline-block;\n}\n\n.tt-host {\n  position: relative;\n  display: inline-block;\n  padding: 6px 12px;\n  background: var(--bg-alt);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-0);\n  font-size: var(--fs-meta);\n  color: var(--text-secondary);\n  cursor: help;\n}\n\n.tt-host--dark {\n  background: var(--ink-dark-2);\n  border-color: var(--ink-rule);\n  color: var(--ink-text-2);\n}\n\n.tooltip-arrow {\n  background: var(--ink-dark);\n  color: var(--cream);\n  padding: 8px 12px;\n  border-radius: var(--radius-0);\n  font-size: var(--fs-xs);\n  line-height: 1.4;\n  max-width: 240px;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  z-index: var(--z-dropdown);\n  white-space: normal;\n  pointer-events: none;\n}\n\n.tooltip-arrow--top {\n  top: auto;\n  bottom: calc(100% + 8px);\n}\n\n.tooltip-arrow--right {\n  left: auto;\n  right: 0;\n}\n\n.tooltip-arrow::before {\n  content: '';\n  position: absolute;\n  top: -4px;\n  left: 24px;\n  width: 8px;\n  height: 8px;\n  background: var(--ink-dark);\n  transform: rotate(45deg);\n}\n\n.tooltip-arrow--top::before {\n  top: auto;\n  bottom: -4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
